import React, { useEffect } from 'react';

export default function Help() {
    useEffect(() => {
        document.title = "TheraMe - Help";
    }, []);

    return (
        <div className="container-fluid px-0 bg-white rounded shadow-sm">
            <div
                className="container-fluid w-100 p-3"
                style={{ backgroundColor: "rgb(51, 178, 234)" }}
            >
                <h1 className="therame-heading text-white mb-3">
                    Welcome to TheraMe Help Resources!
                </h1>
            </div>

            <div className="container py-3">
                <p>
                    These resources are designed to support you in getting the most out of the TheraMe app,
                    empowering you to become more aware of your emotions and feelings, enabling you to gain
                    increased clarity and develop new skills for emotional well-being.
                </p>

                <h4 className="mt-4">How to Get Started: Primer Videos</h4>
                <ul>
                    <li>
                        <a
                            href="https://drive.google.com/file/d/1dNMqtyBjOh6j9tCVRPF01RmRm_OlEZCh/view?usp=sharing"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            TheraMe Journeyer Primer video
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://drive.google.com/file/d/1IzzJ9E2A9pzN8W30IubjnkH1zecA2Myx/view?usp=sharing"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            TheraMe Guide Primer video
                        </a>
                    </li>
                </ul>

                <h4 className="mt-4">Quick Start Guides</h4>
                <ul>
                    <li>
                        <a
                            href="https://docs.google.com/document/d/19m-7Rj8F4yK240XOeSBIrJbfy8AZ8nDJKXjMJve_Ncg/edit?usp=sharing"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            What are emotions – definition
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://docs.google.com/document/d/1JGZj1iBiDngQcSCzJgQyKYHs27oAhDyQcS6qaPhLCL8/edit?usp=sharing"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Journeyer Quick Start Guide
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://docs.google.com/document/d/1mRTX-Q6tDDnk4g-s0mc3Utzezav8qG-HXfJ8cxQgwyY/edit?usp=sharing"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Professional Quick Start Guide
                        </a>
                    </li>
                </ul>

                <h4 className="mt-4">Detailed Descriptions of Emotions and Categories for Journal Entries</h4>
                <p>
                    Guidance for how to discern primary emotions, intensity, body sensations, feelings,
                    experience, perceptions, triggers, and how to respond.
                </p>
                <ul>
                    <li>
                        <a
                            href="https://docs.google.com/document/d/1tUnWbcCC5gSb33Vl205RbB_eLxEUtzMdmCteMExNB8k/edit?usp=sharing"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            For Journeyers
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://docs.google.com/document/d/1kNXDOThHF_7SRRt3C-DSrHTL9fS-gkm5pmsKrQYcefo/edit?usp=sharing"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            For Guides and Professionals
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://docs.google.com/document/d/1l2nEJeP1OotDnGD8Az1LMVkD0S-k0sirXQ5Hmz0NArM/edit?usp=sharing"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            For Young People
                        </a>
                    </li>
                </ul>

                <h4 className="mt-4">Frequently Asked Questions</h4>
                <ul>
                    <li>
                        <a
                            href="https://docs.google.com/document/d/1GLMeMeFEbRuTaLNvcMJV0tXiduF8jjvZ/edit?usp=sharing"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            FAQ
                        </a>
                    </li>
                </ul>

                <h4 className="mt-4">Referral Resources</h4>
                <ul>
                    <li>
                        Guide/Professional referral resources for Journeyers
                        <br />
                        <small className="text-muted">
                            (Forthcoming — if interested, please contact us at{" "}
                            <a href="mailto:accountsupport@thera-me.app">accountsupport@thera-me.app</a>)
                        </small>
                    </li>
                </ul>

                <h4 className="mt-4">Support</h4>
                <ul className="therame-email">
                    <li>
                        Tech Support:{" "}
                        <a href="mailto:techsupport@thera-me.app">techsupport@thera-me.app</a>
                    </li>
                    <li>
                        Account Support:{" "}
                        <a href="mailto:accountsupport@thera-me.app">accountsupport@thera-me.app</a>
                    </li>
                </ul>
            </div>
        </div>

    );
}
